import { ApplicationRef, ComponentRef, Injectable, Injector, createComponent } from '@angular/core'
import { ConfirmDeleteModalComponent } from '@components'

@Injectable({ providedIn: 'root' })
export class ConfirmDeleteModalService {
  private modalRef?: ComponentRef<ConfirmDeleteModalComponent>

  constructor(
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  askUser(title: string, body: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.modalRef = createComponent(ConfirmDeleteModalComponent, {
        environmentInjector: this.appRef.injector,
        elementInjector: this.injector,
      })

      this.modalRef.instance.title = title
      this.modalRef.instance.body = body

      this.modalRef.instance.confirm.subscribe(() => {
        resolve(true)
        this.close()
      })

      this.modalRef.instance.cancel.subscribe(() => {
        resolve(false)
        this.close()
      })

      this.appRef.attachView(this.modalRef.hostView)
      document.body.appendChild(this.modalRef.location.nativeElement)
    })
  }

  private close() {
    if (!this.modalRef) return
    this.appRef.detachView(this.modalRef.hostView)
    this.modalRef.destroy()
    this.modalRef = undefined
  }
}
